import {
  teamsDarkTheme,
  teamsHighContrastTheme,
  teamsLightTheme,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

export const checkInTeams = (): boolean => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isTeamsUserAgent = userAgent.includes("teamsmobile");
  return isTeamsUserAgent || window.top !== window.self;
};

export function getTheme(themeString: string) {
  if (checkInTeams()) {
    if (themeString === "light") {
      return teamsLightTheme;
    } else if (themeString === "dark") {
      return teamsDarkTheme;
    } else if (themeString === "contrast") {
      return teamsHighContrastTheme;
    } else {
      return teamsLightTheme;
    }
  } else {
    if (themeString === "light") {
      return webLightTheme;
    } else if (themeString === "dark") {
      return webDarkTheme;
    } else {
      return webLightTheme;
    }
  }
}
